import { Action } from 'redux';
import { LoadFormPayload, SubmissionRequestPayload } from './../../models/SubmissionModel';
import { LoadFormSuccessData } from './../../models/FormModel';

export enum FormDataActionTypes {
    LOAD_FORM_DATA = 'LOAD_FORM_DATA',
    LOAD_FORM_DATA_SUCCESS = 'LOAD_FORM_DATA_SUCCESS',
    LOAD_FORM_DATA_FAILURE = 'LOAD_FORM_DATA_FAILURE',
    SAVE_FORM_DATA = 'SAVE_FORM_DATA',
    SAVE_FORM_DATA_SUCCESS = 'SAVE_FORM_DATA_SUCCESS',
    SAVE_FORM_DATA_FAILURE = 'SAVE_FORM_DATA_FAILURE',
    UPDATE_FORM = 'UPDATE_FORM',
    UPDATE_FORM_SUCCESS = 'UPDATE_FORM_SUCCESS',
    UPDATE_FORM_FAILURE = 'UPDATE_FORM_FAILURE',
    SAVE_FORM_DATA_RESPONSE = 'SAVE_FORM_DATA_RESPONSE',
    RESET_FORM_DATA = 'RESET_FORM_DATA'
}

export interface LoadFormData extends Action {
    type: FormDataActionTypes.LOAD_FORM_DATA;
    data: LoadFormPayload;
}

export const loadFormData = (data: LoadFormPayload): LoadFormData => ({
    type: FormDataActionTypes.LOAD_FORM_DATA,
    data
});

export interface LoadFormSuccess extends Action {
    type: FormDataActionTypes.LOAD_FORM_DATA_SUCCESS;
    data: LoadFormSuccessData;
}

export const loadFormSuccess = (data: LoadFormSuccessData): LoadFormSuccess => ({
    type: FormDataActionTypes.LOAD_FORM_DATA_SUCCESS,
    data
});

export interface LoadFormFailure extends Action {
    type: FormDataActionTypes.LOAD_FORM_DATA_FAILURE;
}

export const loadFormFailure = (): LoadFormFailure => ({
    type: FormDataActionTypes.LOAD_FORM_DATA_FAILURE
});

export interface SaveFormData extends Action {
    type: FormDataActionTypes.SAVE_FORM_DATA,
    data: SubmissionRequestPayload
}

export const saveFormData = (data: SubmissionRequestPayload): SaveFormData => ({
    type: FormDataActionTypes.SAVE_FORM_DATA,
    data
});

export interface SaveFormDataSuccess extends Action {
    type: FormDataActionTypes.SAVE_FORM_DATA_SUCCESS
    data:any
}

export const saveFormDataSuccess = (data:any): SaveFormDataSuccess => ({
    type: FormDataActionTypes.SAVE_FORM_DATA_SUCCESS,
    data
});

export interface SaveFormFailure extends Action {
    type: FormDataActionTypes.SAVE_FORM_DATA_FAILURE;
    data: any;
}

export const saveFormDataFailure = (data:any): SaveFormFailure => ({
    type: FormDataActionTypes.SAVE_FORM_DATA_FAILURE,
    data
});

export interface UpdateForm extends Action {
    type: FormDataActionTypes.UPDATE_FORM;
    data: any;
}

export const updateForm = (data: any): UpdateForm => ({
    type: FormDataActionTypes.UPDATE_FORM,
    data
});

export interface UpdateFormSuccess extends Action {
    type: FormDataActionTypes.UPDATE_FORM_SUCCESS
}

export const updateFormSuccess = (): UpdateFormSuccess => ({
    type: FormDataActionTypes.UPDATE_FORM_SUCCESS
});

export interface UpdateFormFailure extends Action {
    type: FormDataActionTypes.UPDATE_FORM_FAILURE;
    data: any;
}

export const updateFormFailure = (data:any): UpdateFormFailure => ({
    type: FormDataActionTypes.UPDATE_FORM_FAILURE,
    data
});

export interface SaveFormResponse extends Action {
    type: FormDataActionTypes.SAVE_FORM_DATA_RESPONSE;
    data: any;
}

export const saveFormResponse = (data: any): SaveFormResponse => ({
    type: FormDataActionTypes.SAVE_FORM_DATA_RESPONSE,
    data
});

export interface ResetForm extends Action {
    type: FormDataActionTypes.RESET_FORM_DATA
}

export const resetForm = () : ResetForm => ({
    type: FormDataActionTypes.RESET_FORM_DATA
});

export type FormDataActions = LoadFormData | LoadFormSuccess | LoadFormFailure | SaveFormData
    | SaveFormDataSuccess | SaveFormFailure | UpdateForm | UpdateFormSuccess | UpdateFormFailure |
    SaveFormResponse | ResetForm;